(() => {
  function formatInventory(data) {
    if (!data.inventory_management) {
      return 'Inventory not tracked';
    }

    if (data.inventory_quantity > 0) {
      return `${data.inventory_quantity} in stock`;
    }

    if (data.inventory_policy === 'continue') {
      return 'Available for backorder';
    }

    return 'Out of stock';
  }

  function updateSkuInventory(wrapper, variantId) {
    const jsonEl = wrapper.querySelector('[data-variant-inventory-json]');
    const skuEl = wrapper.querySelector('[data-sku-value]');
    const inventoryEl = wrapper.querySelector('[data-inventory-value]');

    if (!jsonEl || !skuEl || !inventoryEl || !variantId) return;

    let variants = {};

    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.warn('Could not parse variant inventory JSON', error);
      return;
    }

    const data = variants[String(variantId)];
    if (!data) return;

    skuEl.textContent = data.sku || 'N/A';
    inventoryEl.textContent = formatInventory(data);
  }

  function initSkuInventory() {
    const wrappers = document.querySelectorAll('[data-product-sku-inventory]');

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.skuInventoryInitialized === 'true') return;
      wrapper.dataset.skuInventoryInitialized = 'true';

      const productId = wrapper.dataset.productId;

      const variantPicker = document.querySelector(
        `variant-picker[data-product-id="${productId}"]`
      );

      if (!variantPicker) {
        console.warn('Variant picker not found for product', productId);
        return;
      }

      function updateFromCheckedInput() {
        const checkedInput =
          variantPicker.querySelector('input[type="radio"][data-current-checked="true"]') ||
          variantPicker.querySelector('input[type="radio"]:checked');

        if (!checkedInput) return;

        const variantId = checkedInput.dataset.variantId;
        updateSkuInventory(wrapper, variantId);
      }

      variantPicker.addEventListener('change', (event) => {
        const input = event.target;

        if (
          input instanceof HTMLInputElement &&
          input.matches('input[type="radio"][data-variant-id]')
        ) {
          updateSkuInventory(wrapper, input.dataset.variantId);
        }
      });

      variantPicker.addEventListener('click', (event) => {
        const input = event.target.closest?.('input[type="radio"][data-variant-id]');

        if (input) {
          setTimeout(() => {
            updateSkuInventory(wrapper, input.dataset.variantId);
          }, 0);
        }
      });

      const observer = new MutationObserver(() => {
        updateFromCheckedInput();
      });

      observer.observe(variantPicker, {
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'data-current-checked']
      });

      updateFromCheckedInput();
    });
  }

  document.addEventListener('DOMContentLoaded', initSkuInventory);
  document.addEventListener('shopify:section:load', initSkuInventory);

  initSkuInventory();
})();